import { InvoiceItemModel, InvoiceModel, InvoicePaymentModel, InvoiceStatisticsModel, InvoiceAdjustmentModel } from ".";


export class InvoiceSummaryModel {
    Invoice: InvoiceModel;
    InvoiceItems: any[];
    InvoicePayments: InvoicePaymentModel[];
    InvoiceAdjustments: InvoiceAdjustmentModel[];
    Statistics: InvoiceStatisticsModel;
}